import { useContext } from "react";
import { RateContext } from "../providers/RateProvider";

const useRateContext = () => {
  return useContext(RateContext);
};

export default useRateContext;
